import dataApi from '../'

export default {
  /**
   * Get overview of currencies
   */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/admin/settings',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/adminsettings.js